import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { LanguageService } from 'src/app/service/language/language.service';


export interface SELECT_OPTION {
  value:any,
  text:string,
  unique:boolean,
  hide:boolean
}
@Component({
  selector: 'app-select-popover',
  templateUrl: './select-popover.component.html',
  styleUrls: ['./select-popover.component.scss'],
})
export class SelectPopoverComponent implements OnInit, AfterViewInit {

  @ViewChild("virtualScroll") virtualScroll:CdkVirtualScrollViewport;

  @Input() opts:Array<SELECT_OPTION> = [];
  @Input() multiple:boolean;
  itemSize:number = 42;

  values:any[] = [];

  constructor(
    private _popover: PopoverController,
    public lang: LanguageService
  ) { }

  ngOnInit() {}
  ngAfterViewInit() {
    this.scrollToIndex(this.virtualScroll, this.opts, this.values);
  }

  onClick(item) {
    this._popover.dismiss(item);
  }
  multiClick(item:SELECT_OPTION) {
    console.log(item);
    const index = this.values.indexOf(item.value);
    if(index > -1) {
      this.values.splice(index, 1);
    } else {
      if(item.unique) {
        this.values = [item.value];
      } else {
        const unique = this.opts.find(x => x.unique);
        if(unique) {
          const uniqueIndex = this.values.indexOf(unique.value);
          if(uniqueIndex > -1) this.values.splice(uniqueIndex, 1);
        }
        this.values.push(item.value);
      }
    }
  }
  multiSubmit() {
    const selected = this.opts.filter(opt => this.values.includes(opt.value));
    this._popover.dismiss(selected);
  }

  private scrollToIndex(virtualScroll:CdkVirtualScrollViewport, list:Array<{value:string}>, value) {
    const selectedIndex = list.findIndex(item => item.value === value);
    const limitCount = 20;
    let tryCount = 0;
    const initInterval = setInterval(() => {
      if(tryCount >= limitCount) clearInterval(initInterval);
      tryCount++;
      try {
        virtualScroll.scrollToIndex(selectedIndex);
        clearInterval(initInterval);
      } catch(e) {}
    }, 20);
    const $subsChangeIndex = virtualScroll.scrolledIndexChange.subscribe(index => {
      if(index === selectedIndex) {
        clearInterval(initInterval);
        $subsChangeIndex.unsubscribe();
      }
    });
  }
}
